 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		8: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		8: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons","1":"2320ee0835d6f8b2f4ced247aa6af09c7e4fcddf","2":"1bfd94f2973eb13010cf895f21ed9483f98f7c49","3":"4d8f7713b91f7d35f217f7a1d1e898a2ff384616","4":"5829af472d1f44c872f3d64688f0836da65ebd1c","5":"7695358b5badde6b8a5b7b4830241c92e70c32f0","6":"fba06b2473fcfe8ab573b8eb6956c9c4b6b1a3dc","7":"framework","10":"component---gatsby-theme-husky-src-templates-404-404-tsx","11":"component---gatsby-theme-husky-src-templates-article-landing-page-article-landing-page-tsx","12":"component---gatsby-theme-husky-src-templates-article-page-article-page-tsx","13":"component---gatsby-theme-husky-src-templates-article-symptoms-page-index-tsx","14":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","15":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","16":"component---gatsby-theme-husky-src-templates-lds-page-lds-page-tsx","17":"component---gatsby-theme-husky-src-templates-product-page-product-page-tsx","18":"component---gatsby-theme-husky-src-templates-product-quiz-page-product-quiz-page-tsx","19":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","20":"component---gatsby-theme-husky-src-templates-search-result-page-search-result-page-tsx","21":"component---gatsby-theme-husky-src-templates-site-map-page-site-map-page-tsx"}[chunkId]||chunkId) + "-" + {"0":"e80413b9425f29ec595d","1":"41facf439575c3521817","2":"dcdae8814b2869879c98","3":"4cdfeae1c65d3f3c798f","4":"bc49bf9da3a87b4c0803","5":"979823b24276a5d3423a","6":"6c7a54e73253ea37b05b","7":"e00645fcd4677a45b102","10":"60988258488b6445dcb0","11":"186c2e0dd612808082e0","12":"5d0129375aae59c49fa7","13":"fa7bbea8974b224810fc","14":"585fea4c61679eb98ca1","15":"9620e7fc166c905172ff","16":"66aea6d1c9edcb8eaa93","17":"4589df3023f9978d2e08","18":"e3ab3608d37f244d7c3e","19":"b57c49233f7e2f365aee","20":"b0f569ebacbda24434cb","21":"bc813a294a93e35b8d32","24":"cf94cdf8af4d71d707c4","25":"6bde6b6f90b2a822e2dc","26":"eb27bf84a0930ea6ad29","27":"db25fac3e31fab321f33","28":"f5502d5d5fa5c3eb43c0","29":"d5896221fc85f080a91d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"commons","1":"2320ee0835d6f8b2f4ced247aa6af09c7e4fcddf","2":"1bfd94f2973eb13010cf895f21ed9483f98f7c49","3":"4d8f7713b91f7d35f217f7a1d1e898a2ff384616","4":"5829af472d1f44c872f3d64688f0836da65ebd1c","5":"7695358b5badde6b8a5b7b4830241c92e70c32f0","6":"fba06b2473fcfe8ab573b8eb6956c9c4b6b1a3dc","7":"framework","10":"component---gatsby-theme-husky-src-templates-404-404-tsx","11":"component---gatsby-theme-husky-src-templates-article-landing-page-article-landing-page-tsx","12":"component---gatsby-theme-husky-src-templates-article-page-article-page-tsx","13":"component---gatsby-theme-husky-src-templates-article-symptoms-page-index-tsx","14":"component---gatsby-theme-husky-src-templates-contact-us-page-contact-us-page-tsx","15":"component---gatsby-theme-husky-src-templates-home-page-home-page-tsx","16":"component---gatsby-theme-husky-src-templates-lds-page-lds-page-tsx","17":"component---gatsby-theme-husky-src-templates-product-page-product-page-tsx","18":"component---gatsby-theme-husky-src-templates-product-quiz-page-product-quiz-page-tsx","19":"component---gatsby-theme-husky-src-templates-products-list-page-products-list-page-tsx","20":"component---gatsby-theme-husky-src-templates-search-result-page-search-result-page-tsx","21":"component---gatsby-theme-husky-src-templates-site-map-page-site-map-page-tsx"}[chunkId]||chunkId) + "." + {"0":"a6533f0a9f383d866e61","1":"31d6cfe0d16ae931b73c","2":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","10":"eb6de9d72030a786dd73","11":"311f8691b82a949b37bd","12":"e9d1f3c87dc15f3fcb9b","13":"d062f2587872b5229fe9","14":"bf9a784fc1918c3fed3c","15":"d47808d3399d7a677df1","16":"8339e0795ca606108422","17":"20cc6b5454eb2fbf4b62","18":"0cb9012515791f7b09a9","19":"a0e0bf3c1ade91606679","20":"f98312ac819caab27645","21":"b7560e8ce7a20d872ce2","24":"71f642986343521409c3","25":"a9c5c01c1d383b3d0bd3","26":"7005f88c9b1f1b5c216d","27":"f43d9df51d04124d05d9","28":"1e56e7f9b2901d9f6f65","29":"b87f36b2210c5126b4f1"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
